<div #map class="map-container">
  <div hcfMarkerExtension [data]="places" [latitude]="latitude" [longitude]="longitude" [isPopup]="isPopup"></div>
</div>
